import PropTypes from 'prop-types';
import React from 'react';
import { formatDateTime } from '../../library/utilities/intl.js';

export const formatDuration = (totalSeconds) => {
    const s = Math.max(0, Number(totalSeconds) || 0);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    const pad = (n) => String(n).padStart(2, '0');
    return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${pad(m)}:${pad(sec)}`;
};

export const formatCallLine = (log) => {
    const when = log.started_at ? formatDateTime(log.started_at) : '';
    const dir = log.direction === 'inbound' ? 'Incoming call' : 'Outgoing call';
    return `${when} – ${dir} – ${formatDuration(log.duration_sec)}`;
};

const CallSummary = ({ log }) => (
    <span>{formatCallLine(log)}</span>
);

CallSummary.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    log: PropTypes.object.isRequired,
};

export default CallSummary;
